import { styled, TableCell } from '@mui/material';
export const DetailsCell = styled(TableCell)({
    lineHeight: 1,
    padding: '6px 4px',
});
export const LabelCell = styled(TableCell)({
    lineHeight: 1,
    padding: 4,
});
